import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';





@Component({
  selector: 'ngbeditsession',
  templateUrl: './editsession.modal.html',
  styleUrls: ['./editsession.modal.scss']
})

export class NgbEditSession implements OnInit {


  public isRequesting: boolean = false;
  public Showsession: boolean = true;
 



  constructor(public activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit() {




  }

 

  ModalClose() {
    this.activeModal.close();
  }






}
